// src/components/WhyChooseUs.tsx
import React from "react";
import Container from "./ui/Container";
import SectionHeader from "./ui/SectionHeader";
import { CheckCircle2 } from "lucide-react";

const points = [
    {
        title: "Fast loan approvals",
        desc: "Most loans are approved within 24–48 hours after document submission.",
    },
    {
        title: "LIC-backed insurance loans",
        desc: "Unlock liquidity against your LIC policy with clear, fair terms.",
    },
    {
        title: "Trusted partners & banks",
        desc: "We work with reputed banks, NBFCs and real-estate developers to get you the best terms.",
    },
    {
        title: "Minimal documentation",
        desc: "Simple process with minimal paperwork for faster disbursal.",
    },
    {
        title: "24/7 customer support",
        desc: "Phone & WhatsApp support to assist you at every step.",
    },
];

const WhyChooseUs: React.FC = () => {
    return (
        <section id="why" className="py-16 bg-gray-50">
            <Container className="grid gap-8 md:grid-cols-2 items-center">
                <div>
                    <SectionHeader title="Why Choose Us" subtitle="Transparent. Fast. Customer-first." />
                    <ul className="mt-6 space-y-5">
                        {points.map((p) => (
                            <li key={p.title} className="flex items-start gap-4">
                                <CheckCircle2 className="mt-1 h-6 w-6 text-blue-600 flex-shrink-0" />
                                <div>
                                    <h4 className="text-lg font-semibold text-gray-900">{p.title}</h4>
                                    <p className="mt-1 text-sm text-gray-600">{p.desc}</p>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="rounded-2xl overflow-hidden shadow-lg bg-white">
                    <img
                        src="https://images.unsplash.com/photo-1566492031773-4f4e44671857?q=80&w=1400&auto=format&fit=crop"
                        alt="Team meeting and client support"
                        className="w-full h-64 object-cover md:h-full"
                    />
                </div>
            </Container>
        </section>
    );
};

export default WhyChooseUs;
